import React, {useState} from 'react';
import { useRemoteOk } from './hooks/useRemoteOk';
import moment from 'moment';
import { GiWorld } from "react-icons/gi";
import './App.css'
import Navbar from './components/Navbar';

const App = () => {
  const [isActive, setIsActive] = useState({id:null, status:false})
  const {data, isLoading, isError, error} =  useRemoteOk()
  if (isLoading) return <p> Loading ...</p>
  if (isError) return <h2> { error.message}</h2>
  //console.log(data)

  // const handleToggle = () => {
  //   return setIsActive({id:job.id, status:!isActive.status})
  // }

  return (
    <div>
      <Navbar/>
      {/* {data.length} */}
      
      {
        data.map((job) => {
          return(
            <div key={job.id} className = 'jobItem'  onClick= {() => setIsActive({id:job.id, status:!isActive.status})} >
              <div className='all-divisions'>
                <div className='logo-second-division'>
            
                  <img className='image' src={job.company_logo}/>
              
                  <div className='else-second-division'>
                    <div className='job-title-co-name'>
                      <span className='job-title'>{job.title}. </span>
                      <span className='job-name'>{job.company_name}</span>
                    </div>
                    <div className='job-location-category' >
                      <span className='job-location'><GiWorld/>{job.candidate_required_location}</span>
                      <span className='job-category'>{job.category}</span>
                    </div> 
                  </div>
                </div>
                <div className='applybtn-date'>

                  <span>{moment(job.publication_date).fromNow()}</span>
                  <a href={job.url} target= '_blank' className='link-button' rel="noreferrer" >
                    <button>Apply</button>
                  </a> 
                   
                </div>
              </div>
              {isActive.status && job.id === isActive.id? (
                  <div className='job-description'>
                    <div  className='job-description-text' dangerouslySetInnerHTML={{__html:job.description}}/>
                    <div>
                      <a href={job.url} target= '_blank' className='description-button'  rel="noreferrer"  >
                        <button>Apply for this position</button>
                      </a> 
                    </div>
                  </div>
                ):null}
            </div>
          )
        })
      }
      {/* {
        data?.data.jobs.map((job) => {
          return(
            <div key={job.id}>
              {job.title}
              <img src= {job.ompany_logo}/>
              {job.company_name}
              {job.category}
              {job.candidate_required_location}
            </div>
          )
        })
      } */}
    </div>
  );
};

export default App;